/* eslint prefer-template: 0 */
export const getCourseMetaTitle = (page, name) => {
    const titleConfig = {
        stats: 'Racecourse Statistics',
        results: 'Racecourse Results',
        signposts: 'Signposts',
        favourites: 'Favourites Win Rate',
        'course-map': 'Racecourse Map',
        'course-records': 'Course Records',
        'course-info': 'Racecourse Information',
    };

    const title = `${name} Racecourse | ${titleConfig[page]} | Racing Post`;

    window.pageTitle = title;

    return title;
};

const getCourseMetaDescription = (page, name) => {
    const descriptionConfig = {
        stats:
            `Who are the top performers at ${name} Racecourse?
            Find out here with detailed jockey,
            trainer and owner statistics from the Racing Post.`,
        results:
            `Historical race results for ${name} Racecourse.
            Brought to you by the Racing Post.`,
        signposts:
            `${name} signposts & travellers check. Information provided on horses
            that have travelled the furthest to make the race meet, including first
            time blinkers and seven day winners. Courtesy of the Racing Post.`,
        favourites:
            `${name} racecourse favourites. Data covering the last 5 seasons,
            split by horse age as well as handicap. Provided courtesy of the Racing Post.`,
        'course-map':
            `Get a lay of the land with detailed course maps and aerial views of
            ${name} Racecourse. View up to date information on all upcoming races.`,
        'course-records':
            `All the racecourse information you need, brought to you by the Racing Post.
            Distances covered, record course times and RP standard.`,
        'course-info':
            `Your one stop shop for a great day out at ${name}. From ticket prices
            and admissions, to travel and parking information. We've got it all covered!`,
    };

    return descriptionConfig[page];
};

const getCourseMetaData = (page, name) => ({
    title: getCourseMetaTitle(page, name),
    description: getCourseMetaDescription(page, name),
});

export default getCourseMetaData;




// WEBPACK FOOTER //
// ./src/js/shared/metaData/getCourseMetaData.js